import React from 'react';
import Select from './Select'

const path = process.env.PUBLIC_URL

const Guide = ({ choices, handleAnswer, selectedAnswer }) => {
  return (
    <div className="guide intro__container mt-0 md:mt-[2.5vh] rounded-tl-0 rounded-tr-0 md:rounded-tl-[20px] md:rounded-tr-[20px]">
      <h2><span>找错题</span></h2>
      <div className="intro">
        <div className="intro__text">
        以下原歌歌词中，可能存在“敏感内容”，在综艺节目上会被改掉。请找出这个敏感词，点击圈出。
        </div>
      </div>
      <img src={`${path}/images/start.svg`} className="absolute w-[60px] top-[35px] right-[5px] z-10" />
      <img src={`${path}/images/eye.svg`} className="absolute w-[120px] bottom-[26px] left-[50%] z-10 translate-x-[-50%]" />
      <div className="absolute w-[calc(100%_-_60px)]">
        <div className="intro__subtitle">
          【小练习】<br/>星星点灯 ｜ 张天爱等
        </div>
        <div className="intro__demo">
          <Select
            handleAnswer={handleAnswer}
            selectedAnswer={selectedAnswer}
            choices={choices}
          />
        </div>
      </div>
    </div>
  );
};

export default Guide;